'use strict'

document.addEventListener("DOMContentLoaded", () => {
    /*********************************
     * Product slider
     ********************************/
    $(".init-main_js").slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: ".init-nav_js",
    });
    $(".init-nav_js").slick({
        lazyLoad: 'ondemand',
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: ".init-main_js",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    vertical: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                },
            },
        ],
    });

    /*********************************
     * Slider Review
     ********************************/
    const sliderContainer = document.querySelector('.review-box .slider-container');
    const sliderReviewItems = document.querySelectorAll('.slider-review_js .items-slide');
    sliderReviewItems.length > 1 ? sliderReviewActive() : '';

    function sliderReviewActive () {
        $('.slider-review_js').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: true,
            speed: 500,
            arrows : false,
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        adaptiveHeight: true,
                        slidesToShow: 1,
                    }
                }
            ],
        });

        sliderContainer.classList.add('slider-active');
    }

    /*********************************
     * Accordion
     ********************************/
    const accordion = document.querySelector('.grid-faq');

    /*** last item add class ***/
    accordion.querySelectorAll('.items-faq')[accordion.querySelectorAll('.items-faq').length - 1].classList.add('last-item-faq');

    /*** first item opened ***/
    const getFirstItem = accordion.querySelector('.items-faq');
    const firstItemAnswer = getFirstItem.querySelector('.faq-answer');

    getFirstItem.classList.contains('last-item-faq')
        ? firstItemAnswer.style.height = `${firstItemAnswer.querySelector('.faq-content').scrollHeight}px`
        : firstItemAnswer.style.height = `${firstItemAnswer.querySelector('.faq-content').scrollHeight  + 30}px`;


    const accordionInteractive = (accordionItem, accordionContentWrap, accordionContent, triggerTub) => {
        const accordionActive = document.querySelector('.items-faq.active');

        if(accordionItem.classList.contains('active') && !triggerTub){
            accordionItem.classList.remove('active');
            accordionContentWrap.style.height = 0 + 'px';
        } else{
            if(accordionActive){
                accordionActive.classList.remove('active');
                accordionActive.querySelector('.faq-answer').style.height = 0 + 'px';
            }
            accordionItem.classList.add('active');

            accordionItem.classList.contains('last-item-faq')
                ? accordionContentWrap.style.height = `${accordionContentWrap.style.height = accordionContent.scrollHeight}px`
                : accordionContentWrap.style.height = `${accordionContentWrap.style.height = accordionContent.scrollHeight + 30}px`;
        }
    }

    accordion.addEventListener('click', ({target}) => {
        const accordionItem = target.closest('.items-faq');
        const accordionContentWrap = accordionItem.querySelector('.faq-answer');
        const accordionContent = accordionContentWrap.querySelector('.faq-content');

        accordionInteractive(accordionItem, accordionContentWrap, accordionContent, false);
    });

    /*********************************
     * Product navigation
     ********************************/
    const getHeight = (element) => (element ? element.offsetHeight : 0);

    const scrollToElement = (element) => {
        const headerAnnouncementHeight = getHeight(headerAnnouncement);
        const headerHeight = getHeight(siteHeader);
        const stickyTabsHeight = getHeight(stickyTabs);
        const elementTop = element.getBoundingClientRect().top;
        const offsetPosition = elementTop - (headerAnnouncementHeight + headerHeight + stickyTabsHeight);
        const isElementVisible = offsetPosition >= 0 && offsetPosition < window.innerHeight / 2;

        if (!isElementVisible) {
            const scrollToPosition = (window.scrollY + offsetPosition) - 10;
            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth'
            });
        }
    };

    const handleTabClick = (event, index, isSectionAnchor, itemSection) => {
        console.log('handleTabClick')
        event.preventDefault();

        let accordionItem;
        let accordionContentWrap;
        let accordionContent;

        if(!isSectionAnchor){
            console.log('Accordion')
            const target = event.target;
            const tapName = target.closest('.tab-item').querySelector('p').innerHTML.toLocaleString();
            const accordionItems = accordion.querySelectorAll('.items-faq');

            accordionItems.forEach(item => {
                if(item.querySelector('.faq-question span').innerHTML === tapName){
                    accordionItem = item.closest('.items-faq');
                    accordionContentWrap = accordionItem.querySelector('.faq-answer');
                    accordionContent = accordionContentWrap.querySelector('.faq-content')
                }
            });

            accordionInteractive(accordionItem, accordionContentWrap, accordionContent, true);
            setTimeout(() => scrollToElement(faqItems[index]), 500);
        } else{
            console.log('section')
            scrollToElement(document.querySelector(`#${itemSection.getAttribute('id')}`));
        }
    };

    const createNavigationItem = (item, index, isSectionAnchor) => {
        console.log('createNavigationItem')
        const tabItem = document.createElement('div');
        tabItem.classList.add('tab-item');

        const tabItemImage = document.createElement('img');
        tabItemImage.setAttribute('src', item.dataset.image);

        const tabNameWrap = document.createElement('p');
        tabNameWrap.innerHTML = item.dataset.name;

        tabItem.append(tabItemImage, tabNameWrap);
        stickyTabs.append(tabItem);

        tabItem.addEventListener('click', (event) =>
            handleTabClick(event, index, isSectionAnchor, item)
        );
    };

    const createTabNavigation = (accordionItems, sectionAnchorGroup) => {
        console.log('createTabNavigation')
        accordionItems.forEach((item, index) =>
            item.dataset.nav === 'true' ? createNavigationItem(item, index, false) : ''
        );

        if (sectionAnchorGroup.length) {
            sectionAnchor.forEach((item, index) =>
                createNavigationItem(item, index, true)
            );
        }
    };

    const headerAnnouncement = document.querySelector('.header-announcement');
    const siteHeader = document.querySelector('.site-header');
    const stickyTabs = document.querySelector('.sticky-tabs');
    const faqItems = document.querySelectorAll('.items-faq');
    const sectionAnchor = document.querySelectorAll('.section-anchor');

    window.addEventListener('scroll', () => {
        stickyTabs.classList.toggle('scrolled', window.pageYOffset > 0);
    });

    if (faqItems && window.innerWidth < 768) {
        createTabNavigation(faqItems, sectionAnchor);
    }
});